import httpClient from './httpClient';

const API_PREFIX = "mighty/v1/missions";

export default {
  getMission(missionId) {
    return httpClient.get(`${API_PREFIX}/${missionId}`);
  },
  getMissions(missionIds) {
    //get으로는 url이 필요 이상으로 길어질 위험이 있어서 post로 조회
    return httpClient.post(`${API_PREFIX}`,
                           missionIds
    );
  },
  getMissionsByCampaignIds(campaignIds) {
    return httpClient.post(`${API_PREFIX}/campaigns`,
                           campaignIds
    );
  },
  postMission(data) {
    //POST 는 리스트 조회에서 사용하고 있어서 put으로 넣는다.
    return httpClient.put(`${API_PREFIX}`, data);
  },
  updateMission(data) {
    return httpClient.put(`${API_PREFIX}/${data.id}`, data);
  },
  deleteMission(data){
    return httpClient.delete(`${API_PREFIX}/${data.id}`);
  },
  getMissionByCodeName(codeName) {
    return httpClient.get(`${API_PREFIX}/code-names/${codeName}`);
  },
  checkCodeName(codeName){
    return httpClient.post(`${API_PREFIX}/code-names/${codeName}`);
  },

  getLogsByGameUserId(missionId, gameUserId) {
    return httpClient.get(`${API_PREFIX}/${missionId}/game-user-ids/${gameUserId}`);
  },
  getLogsByIdpUserId(missionId, idpType, idpUserId) {
    return httpClient.get(`${API_PREFIX}/${missionId}/idp-type/${idpType}/idp-user-ids/${idpUserId}`);
  },

  getMissionReportByMissionId(missionId){
    return httpClient.get(`${API_PREFIX}/${missionId}/report`);
  }
}
